import styled from '@emotion/styled'
import Icon from '../Icon'

export const StyledToastWrapper = styled.div`
  z-index: 1001;
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
`

const withStyle = (Toast) =>
  styled(Toast)((props) => {
    const color = getColor(props.type, props.theme)
    return `
        margin-top: 5px;
        background: ${props.theme.toastBackground};
        color: ${props.theme.toastColor};
        border: 2px solid;
        border-radius: 3px;
        width: 304px;
        font-family: Arial;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.29;
        letter-spacing: normal;
        border-color: ${color};
        display: flex;
        flex-direction: row;
        box-shadow: 0 8px 8px 0 rgba(7, 7, 15, 0.3);

        i {
          padding-top: 5px;
          align-items: flex-start;
          
          &.anticon-close {
            align-self: flex-start;
          }
        }
      `
  })

export default withStyle

// define min-height here instead of withStyle
// see: https://github.com/philipwalton/flexbugs#flexbug-3
export const IE11FlexWrapper = styled.div`
  display: flex;
  min-height: 40px;
  width: 100%;
`

export const StyledSuccessIcon = styled(Icon)((props) => {
  const color = getColor(props.type, props.theme)
  return `
    .chec-icon { width: 24px; height: 24px; }
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${color};
    font-size: 24px;
    width: 40px;
    height: auto;
    border-radius: 0;
    color: ${props.theme.toastIconColor};
    flex-shrink: 0;
  `
})

export const StyledMessage = styled.div`
  padding: 5px 8px;
  align-self: center;
  flex-grow: 1;
`

export const StyledCloseIcon = styled(Icon)`
  font-size: 12px;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  align-self: center;
  margin-left: auto;
  flex-shrink: 0;
`

const getColor = (type, theme) => {
  const types = {
    success: theme.toastSuccessBgColor,
    info: theme.toastInfoBgColor,
    warning: theme.toastWarningBgColor,
    error: theme.toastErrorBgColor,
  }

  return types[type]
}
